import { Meeting } from "./meeting";
import { Sdk } from "./sdk";
import { Ppt } from "./ppt";
import { User } from "./user";
import { Lint } from "./link";
import { cr } from "fire-wind-water";
import info from "./status";
import { combineLatest } from "rxjs";
import {
  SdkEventParameter,
  MeetingParameter,
  skMeetingEventParamenter,
  PptEventParameter,
  UserEventParameter,
} from "./interface";

const module = (window as any).$sk.template;
const meeting = new Meeting();
const sdk = new Sdk();
const ppt = new Ppt();
const user = new User();
const link = new Lint();
class WebinarModule {
  static modules: { [label: string]: string | any }[] = [];
  static status: any = {};
  first = true;
  skModuleType: string[] = ["webinar"];
  constructor() {
    // const _this = this;
    combineLatest([info.meeting.mettingEnd, info.user.userEnd]).subscribe(
      () => {
        setTimeout(async () => {
          const webinarInfo = this.get().meetingInfo;
          const userInfo = this.get().user;
          await link.init({ webinarInfo, userInfo }).then((data) => {
            if (data.isJump) {
              if (this.first) {
                this.skMeetingLinkEnd(data);
                this.first = false;
              }
            }
          });
        }, 100);
      }
    );
    module.pushModule(this);
    module.module(this); //skMeetingLinkStart  跳转之前  skMeetingLinkEnd 跳转结束  skMeetingChange
    // 会议信息和会议状态发生改变（包括会议信息异常）     skMeetingStatus  //{tyepe:'message'}//{tyepe:'mettingStatus'}
    meeting.module(
      this.injection([
        "skMeetingLinkStart",
        "skMeetingLinkEnd",
        "skMeetingChange",
        "skMeetingStatus",
      ])
    );
    //'skWebianrUserEnd',获取用户信息结束  'skWebinarUserChange' 用户信息发生改变,  skWebinarUserChange
    //{tyepe:'message'}
    user.module(this.injection(["skWebianrUserEnd", "skWebinarUserChange"]));
    //skPlayerStatus  视频状态 比如直播中  skPlayerInit 目睹sdk播放器准备完成 skSdkVideoChangeUrl 视频流发生改变 skPlayer 视频播放  skEnded视频结束 skStoped 视频暂停 skPlayerRemove 视频销毁
    sdk.module(
      this.injection([
        "skPlayerStatus",
        "skPlayerInit",
        "skSdkVideoChangeUrl",
        "skPlayer",
        "skEnded",
        "skStoped",
        "skPlayerRemove",
        "skPolyvNews",
      ])
    );
    //skPptInfoChange  ppt 改变包括翻页等 添加type 用来区分是 开关改变还是 翻页 删除等改变
    ppt.module(this.injection(["skPptInfoChange"]));
    link.module(
      this.injection([
        "skMeetingLinkStart",
        "skMeetingLinkEnd",
        "skMeetingChange",
      ])
    );
  }

  injection(s: string[]) {
    const o: any = {};
    cr.each(s, (d) => {
      o[d] = (...args) => {
        this[d](args);
      };
    });
    return o;
  }

  update(o: MeetingParameter) {
    meeting.init({
      page: o.data.page,
      needJump: o.data.needJump,
      webinarId: o.data.webinarId,
      instanceId: o.data.instanceId,
      tenantId: o.data.tenantId,
      needLogin: o.data.needLogin,
      type: o.data.type,
      needRegistration: o.data.needRegistration,
      unLimit: o.data.unLimit,
      isReleased: o.data.isReleased,
      isClosed: o.data.isClosed,
      isOpen: o.data.isOpen,
      replaySwitch: o.data.replaySwitch,
      trailFlag: o.data.trailFlag,
      registrationFormId: o.data.registrationFormId, //注册标点
      customFormId: o.data.customFormId, //报名表单
      weChatId: o.data.weChatId,
    });
  }

  module(o: any): { [label: string]: any } {
    const key = `sk_temp_webinar_module_${new Date().getTime()}`;
    WebinarModule.modules.push({
      key,
      model: o,
    });
    if (WebinarModule.status.mettingLinkEnd) {
      if (o.skMeetingLinkEnd) {
        o.skMeetingLinkEnd();
      }
    }
    return {
      unsubscribe() {
        WebinarModule.modules = WebinarModule.modules.filter((d) => {
          return d.key !== key;
        });
      },
    };
  }

  // 根据会议状态判断需要跳转时，跳转前触发
  skMeetingLinkStart(data) {
    cr.each(WebinarModule.modules, (d) => {
      if (d.model.skMeetingLinkStart) {
        d.model.skMeetingLinkStart(data);
      }
    });
  }
  //跳转结束
  skMeetingLinkEnd(data) {
    cr.each(WebinarModule.modules, (d) => {
      if (d.model.skMeetingLinkEnd) {
        d.model.skMeetingLinkEnd(data);
      }
    });
    WebinarModule.status.mettingLinkEnd = true;
  }
  //   会议信息和会议状态发生改变（包括会议信息异常）
  skMeetingChange(data) {
    console.log("会议状态发生变化，通知外部 modul", data);
    cr.each(WebinarModule.modules, (d) => {
      if (d.model.skMeetingChange) {
        d.model.skMeetingChange(data);
      }
    });
  }
  //获取用户信息结束
  skWebianrUserEnd(data) {
    cr.each(WebinarModule.modules, (d) => {
      if (d.model.skWebianrUserEnd) {
        d.model.skWebianrUserEnd(data);
      }
    });
  }
  //用户信息发生改变
  skWebinarUserChange(data) {
    console.log("module skWebinarUserChange");
    cr.each(WebinarModule.modules, (d) => {
      if (d.model.skWebinarUserChange) {
        d.model.skWebinarUserChange(data);
      }
    });
  }
  //用户状态
  skUserStatusChange(data) {
    cr.each(WebinarModule.modules, (d) => {
      if (d.model.skUserStatusChange) {
        d.model.skUserStatusChange(data);
      }
    });
  }
  //播放器的状态 比如播放中 暂无直播
  skPlayerStatus(data) {
    cr.each(WebinarModule.modules, (d) => {
      if (d.model.skPlayerStatus) {
        d.model.skPlayerStatus(data);
      }
    });
  }
  //目睹sdk播放器准备完成
  skPlayerInit(data) {
    cr.each(WebinarModule.modules, (d) => {
      if (d.model.skPlayerInit) {
        d.model.skPlayerInit(data);
      }
    });
  }
  //视频流发生改变
  skSdkVideoChangeUrl(data) {
    cr.each(WebinarModule.modules, (d) => {
      if (d.model.skSdkVideoChangeUrl) {
        d.model.skSdkVideoChangeUrl(data);
      }
    });
  }
  //视频流发生改变
  skPlayer(data) {
    cr.each(WebinarModule.modules, (d) => {
      if (d.model.skPlayer) {
        d.model.skPlayer(data);
      }
    });
  }
  //skEnded视频结束
  skEnded(data) {
    cr.each(WebinarModule.modules, (d) => {
      if (d.model.skEnded) {
        d.model.skEnded(data);
      }
    });
  }
  //skEnded视频结束
  skStoped(data) {
    cr.each(WebinarModule.modules, (d) => {
      if (d.model.skStoped) {
        d.model.skStoped(data);
      }
    });
  }
  skPolyvNews(data) {
    cr.each(WebinarModule.modules, (d) => {
      if (d.model.skPolyvNews) {
        d.model.skPolyvNews(data);
      }
    });
  }
  //skEnded视频结束
  skPlayerRemove(data) {
    cr.each(WebinarModule.modules, (d) => {
      if (d.model.skPlayerRemove) {
        d.model.skPlayerRemove(data);
      }
    });
  }
  //skPptInfoChange  ppt 改变包括翻页等 添加type 用来区分是 开关改变还是 翻页 删除等改变
  skPptInfoChange(data) {
    cr.each(WebinarModule.modules, (d) => {
      if (d.model.skPptInfoChange) {
        d.model.skPptInfoChange(data);
      }
    });
  }
  get() {
    return {
      meetingInfo: meeting.webinarInfo,
      user: user.info,
      skd: {
        isPlaye: sdk.isPlaye,
      },
      canJoin: function (webinar, user) {
        return meeting.canJoin(webinar, user);
      },
      canEnter: function (webinar, user) {
        return meeting.canEnter(webinar, user);
      },
    };
  }

  // 外部调用sdk方法
  skSdkEvent(o: SdkEventParameter) {
    sdk.skEvent(o);
  }

  // 外部调用ppt方法
  skPptEvent(o: PptEventParameter) {
    ppt.skPptEvent(o);
  }

  skMeetingEvent(o: skMeetingEventParamenter) {
    return meeting.skMeetingEvent(o);
  }

  skUserEvent(o: UserEventParameter) {
    user.skUserEvent(o);
  }
}

export const webinar = new WebinarModule();
